import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import { toISO3 } from "@src/cloud-connect/user-manager/utils/to-iso3";
import store from "@src/reducers/store";
import { Language } from "@src/reducers/your-reducer";
import { GetSupportTicketsResponse } from "@src/types/support";

export interface GetSupportTicketsResult {
  success: boolean;
  data?: GetSupportTicketsResponse;
  error?: string;
}

export const getSupportTicketsWithLanguageUseCase = async (
  language: Language,
  userId?: string,
): Promise<GetSupportTicketsResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;

    const ISO6393Language = toISO3(language);

    const response = await apiUseCases.getSupportTicketsWithLanguage(
      namespace,
      ISO6393Language,
      userId,
    );

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to fetch tickets").message,
    };
  }
};
